import { useEffect, useState } from "react";

interface TimerProps {
  startTime: any;
}

const Timer: React.FC<TimerProps> = ({ startTime }) => {
  const [elapsedTime, setElapsedTime] = useState<number>(0);

  useEffect(() => {
    const startDate = new Date(startTime);

    const interval = setInterval(() => {
      setElapsedTime(
        Math.floor((new Date().getTime() - startDate.getTime()) / 1000)
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  const days = Math.floor(elapsedTime / (60 * 60 * 24));
  const hours = Math.floor((elapsedTime % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((elapsedTime % (60 * 60)) / 60);
  const seconds = elapsedTime % 60;

  return (
    <div className="text-center font-medium">
      <span>{days}d </span> <span>{hours}h </span> <span>{minutes}m </span>{" "}
      <span>{seconds}s</span>
    </div>
  );
};

export default Timer;
